/* =================== DETALHE PRODUTO =================== */
jQuery(document).ready(function ($) {
  var dots = $(".produto-detalhe-fotos-destaque li").length > 1;
  // Carrosel fotos
  $(".produto-detalhe-fotos-destaque").slick({
    slidesToShow: 1,
    infinite: false,
    dots: false,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: ".produto-detalhe-fotos-thumbs",
    responsive: [
      {
        breakpoint: 480,
        settings: {
          dots: false,
          arrows: false,
        },
      },
    ],
  });

  // Carrosel thumbs
  $(".produto-detalhe-fotos-thumbs").slick({
    slidesToShow: 4,
    infinite: false,
    slidesToScroll: 1,
    focusOnSelect: true,
    arrows: false,
    asNavFor: ".produto-detalhe-fotos-destaque",
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  // Categorias Mobile
  $("#produtos-cat").on("change", alteraCampoCat);

  function alteraCampoCat() {
    const categoria = $("#produtos-cat").val();
    location.href = categoria;
  }
});
